import { purple, orange, pink, green, yellow, grey } from "@mui/material/colors";
export const california = {
  50: '#fffaea',
  100: '#fff3c6',
  200: '#ffe587',
  300: '#ffd049',
  400: '#ffbb1f',
  500: '#fb9c0c',
  600: '#de7101',
  700: '#b84d05',
  800: '#953b0b',
  900: '#7b310c',
  950: '#471701',
};

export const chateauGreen = {
  50: '#edfcf2',
  100: '#d2f9de',
  200: '#aaf0c4',
  300: '#72e3a3',
  400: '#3acd7e',
  500: '#16b364',
  600: '#0a9150',
  700: '#087442',
  800: '#095c37',
  900: '#094b2f',
  950: '#032b1a',
};

export const kepple = {
  50: '#f0fdfa',
  100: '#ccfbef',
  200: '#9af5e1',
  300: '#5fe9ce',
  400: '#2ed3b8',
  500: '#15b79f',
  600: '#0e9382',
  700: '#107569',
  800: '#115e56',
  900: '#134e48',
  950: '#042f2c',
};

export const neonBlue = {
  50: '#ecf0ff',
  100: '#dde3ff',
  200: '#c2cbff',
  300: '#9ca7ff',
  400: '#7578ff',
  500: '#635bff',
  600: '#4e36f5',
  700: '#432ad8',
  800: '#3725ae',
  900: '#302689',
  950: '#1e1650',
};

export const nevada = {
  50: '#fbfcfe',
  100: '#f0f4f8',
  200: '#dde7ee',
  300: '#cdd7e1',
  400: '#9fa6ad',
  500: '#636b74',
  600: '#555e68',
  700: '#32383e',
  800: '#202427',
  900: '#121517',
  950: '#090a0b',
};

export const redOrange = {
  50: '#fef3f2',
  100: '#fee4e2',
  200: '#ffcdc9',
  300: '#fdaaa4',
  400: '#f97970',
  500: '#f04438',
  600: '#de3024',
  700: '#bb241a',
  800: '#9a221a',
  900: '#80231c',
  950: '#460d09',
};

export const royalBlue = {
  50: '#ecf3ff',
  100: '#dce8ff',
  200: '#c0d4ff',
  300: '#9bb6ff',
  400: '#738dff',
  500: '#5265ff',
  600: '#3339f8',
  700: '#3739de',
  800: '#2225b1',
  900: '#24298b',
  950: '#151651',
};

export const shakespeare = {
  50: '#ecfdff',
  100: '#cff7fe',
  200: '#a4eefd',
  300: '#66e0fa',
  400: '#10bee8',
  500: '#04aad6',
  600: '#0787b3',
  700: '#0d6d91',
  800: '#145876',
  900: '#154964',
  950: '#082f44',
};

export const neonPurple = {
  50: "#F5F0FF",
  100: "#EEE5FF",
  200: "#D9C7FF",
  300: "#C7ADFF",
  400: "#B28FFF",
  500: "#A175FF",
  600: "#6D29FF",
  700: "#4700E0",
  800: "#2F0094",
  900: "#18004D",
  950: "#0B0024"
}

export const neonPink = {
  50: "#FFF0FC",
  100: "#FFE0F8",
  200: "#FFBDF1",
  300: "#FF9EEA",
  400: "#FF7AE2",
  500: "#FF5BDB",
  600: "#FF14CC",
  700: "#D100A4",
  800: "#8A006C",
  900: "#470038",
  950: "#24001C"
}

export const stormGrey = {
  50: '#f9fafb',
  100: '#f1f1f4',
  200: '#dcdfe4',
  300: '#b3b9c6',
  400: '#8a94a6',
  500: '#667085',
  600: '#565e73',
  700: '#434a60',
  800: '#313749',
  900: '#212636',
  950: '#121621',
};

export const tomatoOrange = {
  50: '#fff3ed',
  100: '#ffe2d4',
  200: '#ffc1a8',
  300: '#ffa280',
  400: '#ff9771',
  500: '#ff6c47',
  600: '#fe4011',
  700: '#ed3507',
  800: '#9f2c0f',
  900: '#7e1110',
  950: '#440608',
};

export const textColors = {
  'red': redOrange[500],
  'orange': california[600],
  'yellow': california[400],
  'green': chateauGreen[500],
  'blue': shakespeare[400],
  'purple': neonBlue[500],
  'black': 'text.primary', // black and white need to be responsive for light/dark mode
  'white': 'text.primary'
  // 'black': nevada[900],
  // 'white': nevada[50]
}


// Using (mostly the same hex codes as skyspark)
// export const chartColors = {
//   'blue': '#3498db',
//   'red': '#e74c3c',
//   'green': '#27ae60',
//   'purple': '#9b59b6',
//   'orange': '#ff7c01ff',
//   'pink': '#FF5BDB',
//   'yellow': '#f1de0f',
//   'teal': '#35dbba',
//   'brown': '#895129'
// }

// Using hex codes more in line with website theme
export const chartColors = {
  'blue': '#2562FF',
  'red': redOrange[500],
  'green': chateauGreen[400],
  'purple': '#905CFE',
  'orange': california[500],
  'pink': neonPink[500],
  'yellow': california[400],
  'teal': '#35dbba',
  'brown': '#895129'
}

export const chipColors = {
  'red': {
    50: 'var(--mui-palette-error-50)',
    100: 'var(--mui-palette-error-100)',
    200: 'var(--mui-palette-error-200)',
    400: 'var(--mui-palette-error-400)',
    500: 'var(--mui-palette-error-500)',
    700: 'var(--mui-palette-error-700)',
    800: 'var(--mui-palette-error-800)'
  },
  'yellow' : {
    50: 'var(--mui-palette-warning-50)',
    100: 'var(--mui-palette-warning-100)',
    200: 'var(--mui-palette-warning-200)',
    400: 'var(--mui-palette-warning-400)',
    500: 'var(--mui-palette-warning-500)',
    700: 'var(--mui-palette-warning-700)',
    800: "#AF7E03"
  },
  'orange': {
    50: orange[50],
    100: orange[100],
    200: orange[200],
    400: orange[400],
    500: orange[500],
    700: '#C44602',
    800: '#A23A01'
  },
  // 'green' : {
  //   50: 'var(--mui-palette-success-50)',
  //   100: 'var(--mui-palette-success-100)',
  //   200: 'var(--mui-palette-success-200)',
  //   400: 'var(--mui-palette-success-400)',
  //   500: 'var(--mui-palette-success-500)',
  //   700: 'var(--mui-palette-success-700)',
  //   800: 'var(--mui-palette-success-800)'
  // },
  'green': {
    50: green[50],
    100: green['A100'],
    200: green[200],
    400: green[400],
    500: green[500],
    700: green[900],
    800: green[900]
  },
  'blue' : {
    50: 'var(--mui-palette-primary-50)',
    100: 'var(--mui-palette-primary-100)',
    200: 'var(--mui-palette-primary-200)',
    400: 'var(--mui-palette-primary-400)',
    500: 'var(--mui-palette-primary-500)',
    700: 'var(--mui-palette-primary-700)',
    800: 'var(--mui-palette-primary-800)'
  },
  'purple': neonPurple,
  'pink': neonPink,
  'grey': {
    50: 'var(--mui-palette-secondary-50)',
    100: 'var(--mui-palette-secondary-100)',
    200: 'var(--mui-palette-secondary-200)',
    400: 'var(--mui-palette-secondary-400)',
    500: 'var(--mui-palette-secondary-500)',
    700: 'var(--mui-palette-secondary-700)',
    800: 'var(--mui-palette-secondary-800)'
  },
  'gray': {
    50: 'var(--mui-palette-secondary-50)',
    100: 'var(--mui-palette-secondary-100)',
    200: 'var(--mui-palette-secondary-200)',
    400: 'var(--mui-palette-secondary-400)',
    500: 'var(--mui-palette-secondary-500)',
    700: 'var(--mui-palette-secondary-700)',
    800: grey[800]
  },
}